module.exports = __webpack_public_path__ + "static/media/side-bar-teams-icon-non-active.252c1fc7.svg";